import {
  IOrderState,
  ORDER_SET_DATA,
  ORDER_TOGGLE_LOADING,
  OrderActionTypes,
  ORDER_RESET_DATA,
  ORDER_SET_ACTIVITY,
  ORDER_ASSIGN_ACTIVITY_IS_OPEN_FIELDS,
  ORDER_TOGGLE_ACTIVITY_IS_OPEN,
  ORDER_TOGGLE_ACTIVITY_CONTENT_LOADING,
  ORDER_SET_ACTIVITY_ERROR,
} from './types'

const initialState: IOrderState = {
  loading: false,
  loadingActivities: false,
  data: {
    orderNumber: '',
    name: '',
    status: '',
    createdOn: '',
    modifiedOn: '',
    orderType: '',
    products: [],
    projectManager: {
      firstName: '',
      lastName: '',
      name: '',
      email: '',
      telephone: '',
    },
    activities: [],
  },
}

export function orderReducer(state = initialState, action: OrderActionTypes) {
  switch (action.type) {
    case ORDER_SET_DATA:
      return {
        ...state,
        data: action.data,
      }
    case ORDER_TOGGLE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      }
    case ORDER_RESET_DATA:
      return {
        ...initialState,
      }
    case ORDER_ASSIGN_ACTIVITY_IS_OPEN_FIELDS:
      return {
        ...state,
        data: {
          ...state.data,
          activities: state.data.activities.map((activity) => ({
            ...activity,
            isOpen: false,
          })),
        },
      }
    case ORDER_TOGGLE_ACTIVITY_IS_OPEN:
      const { data } = state
      const { activities } = data
      const { id } = action
      const updatedActivities = activities.map((activity) => {
        if (activity.id === id) {
          return { ...activity, isOpen: !activity.isOpen }
        }
        return activity
      })
      return {
        ...state,
        data: { ...state.data, activities: [...updatedActivities] },
      }
    case ORDER_TOGGLE_ACTIVITY_CONTENT_LOADING:
      return {
        ...state,
        data: {
          ...state.data,
          activities: state.data.activities.map((activity) => {
            if (activity.id === action.id) {
              return {
                ...activity,
                contentLoading: !activity.contentLoading,
              }
            }
            return activity
          }),
        },
      }
    case ORDER_SET_ACTIVITY_ERROR:
      return {
        ...state,
        data: {
          ...state.data,
          activities: state.data.activities.map((activity) => {
            if (activity.id === action.id) {
              return { ...activity, error: action.error }
            }
            return activity
          }),
        },
      }
    case ORDER_SET_ACTIVITY:
      return {
        ...state,
        data: {
          ...state.data,
          activities: state.data.activities.map((activity) => {
            if (activity.id === action.data.id) {
              return { ...activity, ...action.data }
            }
            return activity
          }),
        },
      }
    default:
      return {
        ...state,
      }
  }
}
